import {
    Component 
} from "@angular/core";

@Component({
    selector: 'mdk-mo-card-faces',
    templateUrl: './mo-card-faces.component.svg'
})
export class MoCardFacesComponent {}